import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { AsyncPipe, NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { ShIndeterminateDirective } from '../../../directives/indeterminate.directive';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormFourStateCheckboxComplexBaseComponent } from '../base-complex/form-four-state-checkbox-complex-base.component';

@Component({
    selector: 'sh-form-four-state-checkbox-base',
    templateUrl: '../base-complex/form-four-state-checkbox-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormFourStateCheckboxBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, ShIndeterminateDirective, NgIf, AsyncPipe]
})
export class ShFormFourStateCheckboxBaseComponent extends ShFormFourStateCheckboxComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<boolean | null>): void {
        this.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
